import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['input', 'show', 'hide'];

  show() {
    this.hideTarget.classList.remove('hidden');
    this.showTarget.classList.add('hidden');
    this.inputTarget.type = 'text';
  }

  hide() {
    this.hideTarget.classList.add('hidden');
    this.showTarget.classList.remove('hidden');
    this.inputTarget.type = 'password';
  }
}
